import Cleave from "cleave.js";
// import "cleave.js/dist/addons/cleave-phone.us";

const cleaveDirective = {
  inserted: (el, binding) => {
    // True if cleave directive is used on vuetify-elements
    const isVuetifyInput = el.classList.contains("v-input");
    // Cleave directive will bind itself to this element
    const cleaveElement = isVuetifyInput ? el.querySelector("input") : el;
    // eslint-disable-next-line no-unused-vars
    const { _initValue, ...directiveValues } = binding.value;
    const isDirectiveApplied = Object.keys(directiveValues).length > 0;
    el.cleave = isDirectiveApplied ? new Cleave(cleaveElement, binding.value || {}) : undefined;
  },
  update: (el, binding) => {
    const isVuetifyInput = el.classList.contains("v-input");
    const cleaveElement = isVuetifyInput ? el.querySelector("input") : el;

    const event = new Event("input", { bubbles: true });
    setTimeout(function () {
      const newValue = binding.value.value;
      const oldValue = binding.oldValue.value;
      if (newValue !== oldValue) cleaveElement.dispatchEvent(event);
    }, 100);
  },
};

export default cleaveDirective;
